/**
 * Style dùng chung cho overlay “đã chọn” (click preview) và overlay khi mở section từ Navigate.
 * `position: absolute` + toạ độ theo shadow host — App Bridge Max Modal thường có `transform`,
 * khiến `position: fixed` + viewport rect lệch (hover như mất).
 */
export const FD_SELECTED_OVERLAY_PAIR_CSS = `
.fd-selected-overlay,
.fd-sidebar-nav-overlay {
  position: absolute;
  pointer-events: none;
  box-sizing: border-box;
  z-index: 2147483645;
  display: none;
  border: 1px solid #00bfff;
  background: rgba(52, 168, 83, 0.03);
  will-change: transform, width, height;
}
.fd-selected-tag,
.fd-sidebar-nav-tag {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-2px, -100%);
  background: #00bfff;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif;
  padding: 4px 6px;
  border-radius: 0;
  pointer-events: none;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
`;
